// The approve half of answering a task, shared by a row's actions and the task
// drawer: inline, or on the signing page when the stage needs the approver's
// passkey (see taskApproval.ts). Once signed, the signing page comes back here.

import { useLocation } from "react-router-dom";

import { useApprovalSigning } from "pages/Members/StepUp/useApprovalSigning";
import type { MFTaskItem, TaskDecision } from "state/members/tasks";

import { approveTask } from "./taskApproval";

export const useTaskApproval = (
  task:
    | Pick<MFTaskItem, "assigneeId" | "entityId" | "passkeyRequired">
    | null
    | undefined,
  respond: (decision: TaskDecision, comment?: string) => Promise<unknown>,
) => {
  const { pathname } = useLocation();
  const { sign, isStarting } = useApprovalSigning();

  // An access approval's entity is its request. Every assignment row names
  // both ids; without them there is nothing to sign.
  const signTask = async (comments?: string) => {
    const requestId = task?.entityId;
    const assigneeId = task?.assigneeId;
    if (!requestId || !assigneeId) return false;
    return sign({ requestId, assigneeId, returnTo: pathname, comments });
  };

  return {
    needsPasskey: Boolean(task?.passkeyRequired),
    isStarting,
    /** The note goes with the answer, inline or from the signing page. */
    approve: (note?: string) =>
      approveTask(task?.passkeyRequired, note, {
        respond: (comment) => respond("approve", comment),
        sign: signTask,
      }),
  };
};
